// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import SyncPatientMatchingCard from './data'

export default function SyncPatientMatchingCardFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/SyncPatientMatchingCard">
      <SyncPatientMatchingCard {...props}>
        {children}
      </SyncPatientMatchingCard>
    </Flow>
  )
}
